import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import LoginPopup from "../../components/Login/LoginPopup";
import Auth from "../Auth/Auth";

const HeadlineSection = () => {
  const [openLogin, setOpenLogin] = useState(false);
  const { isLoggedIn } = Auth();

    return (
        <Box sx={{ height: "100%", alignContent:"center"}}>
            <Typography variant="h1" stgutterBottom textAlign="left">
                Design circuits smarter with <span className="sniglet-font-text">PHYtool</span>
            </Typography>
            <br />
            <Typography variant="body1" className="app-description">
                Create and edit schematics and stick-diagrams easily with our intuitive web based editor.
            </Typography>
            <br />
          {!isLoggedIn && (
          <Button variant="contained" onClick={() => setOpenLogin(true)}>Sign up and start designing</Button>
          )}
            {openLogin && <LoginPopup open={openLogin} onClose={()=>{setOpenLogin(false)}} />}
        </Box>
    );
};

export default HeadlineSection;
